module.exports = __webpack_public_path__ + "static/fonts/NotoSansCJKkr-DemiLight.4028af3.otf";